<app-modal>
  <ng-container class="title">
    {{ 'documents.viewSettings.action' | transloco }}
  </ng-container>
  <ng-container class="actions">
    <button type="button" class="button-tertiary ms-3" (click)="modal.close()">
      {{ 'action.close' | transloco | uppercase }}
    </button>
  </ng-container>

  <ng-container class="content">
    <div>
      <label for="viewMode" class="form-label fw-semibold">{{ 'documents.viewSettings.showResultsAs' | transloco }}</label>
      <select [formControl]="viewMode" (change)="updateViewMode()" class="form-select" id="viewMode">
        <option [value]="DocumentsViewMode.card">{{ 'documents.viewSettings.asCards' | transloco }}</option>
        <option [value]="DocumentsViewMode.table">{{ 'documents.viewSettings.asTable' | transloco }}</option>
      </select>
    </div>

    <div class="row mt-4" *ngIf="viewSettings.columns$ | async as columns">
      <label class="form-label fw-semibold">{{ 'documents.viewSettings.showColumns.action' | transloco }}</label>
      <div class="col-6">
        <h3 class="font-weight-bold my-2">{{ 'documents.viewSettings.showColumns.sections.roles' | transloco }}</h3>
        <app-displayable-item [item]="columns.client"
                              (itemChanged)="columns.client=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.consignor"
                              (itemChanged)="columns.consignor=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.consignee"
                              (itemChanged)="columns.consignee=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.carrier"
                              (itemChanged)="columns.carrier=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.subcontractor"
                              (itemChanged)="columns.subcontractor=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.placeOfTakingOver"
                              (itemChanged)="columns.placeOfTakingOver=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.placeOfDelivery"
                              (itemChanged)="columns.placeOfDelivery=$event;columnsChanged(columns)"></app-displayable-item>
      </div>

      <div class="col-6">
        <h3 class="font-weight-bold my-2">{{ 'documents.viewSettings.showColumns.sections.dates' | transloco }}</h3>
        <app-displayable-item [item]="columns.agreedDateOfTakingOver"
                              (itemChanged)="columns.agreedDateOfTakingOver=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.agreedDateOfDelivery"
                              (itemChanged)="columns.agreedDateOfDelivery=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.establishedDate"
                              (itemChanged)="columns.establishedDate=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.lastModified"
                              (itemChanged)="columns.lastModified=$event;columnsChanged(columns)"></app-displayable-item>

        <h3 class="font-weight-bold mt-3 mb-2">{{ 'documents.viewSettings.showColumns.sections.others' | transloco }}</h3>
        <app-displayable-item [item]="columns.references"
                              (itemChanged)="columns.references=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.flags"
                              (itemChanged)="columns.flags=$event;columnsChanged(columns)"></app-displayable-item>
        <app-displayable-item [item]="columns.vehicle"
                              (itemChanged)="columns.vehicle=$event;columnsChanged(columns)"></app-displayable-item>
      </div>

    </div>
  </ng-container>
</app-modal>
